import { useEffect, useState } from "react";
import { getCustomTovs, deleteCustomTovs, getDefaultValues } from "../../services/app.service";
import { PERSONA_INITIAL_OBJECT } from "../settings";
import { showApiErrorToast } from "../../components/notify";

const useToneOfVoice = ({
  tovFormMode,
  EMPTY_BRAND,
  setLoadingOnSave,
  setShowDeleteView,
  setShowTovForm,
  setTovFormMode,
  setTypeSelection,
  setTovOption,
  setTempSelectedDivision,
  setTempSelectedBrand,
  setTempSelectedPersona,
  setSelectedTovId,
}: {
  tovFormMode: string;
  EMPTY_BRAND: Brand;
  setLoadingOnSave: (v: boolean) => void;
  setShowDeleteView: (v: boolean) => void;
  setShowTovForm: (v: boolean) => void;
  setTovFormMode: (v: string) => void;
  setTypeSelection: (v: string) => void;
  setTovOption: (v: string) => void;
  setTempSelectedDivision: (v: string) => void;
  setTempSelectedBrand: (v: Brand) => void;
  setTempSelectedPersona: (v: Persona) => void;
  setSelectedTovId: (v: string) => void;
}) => {
  const [customTovs, setCustomTovs] = useState<any[]>([]);
  const [selectedTovName, setSelectedTovName] = useState("");
  const [customName, setCustomName] = useState("");
  const [instruction, setInstruction] = useState("");

  // Fetch custom ToVs
  useEffect(() => {
    const fetchCustomTovs = async () => {
      const res = await getCustomTovs();
      const tovs = Array.isArray(res?.data) ? res.data : [];
      setCustomTovs(tovs);
      if (tovs.length > 0) {
        setSelectedTovName(tovs[0].name);
        setCustomName(tovs[0].name);
        setInstruction(tovs[0].instruction);
      }
    };

    fetchCustomTovs();
  }, []);

  const selectedTovObj = customTovs.find((tov) => tov.name === selectedTovName) ?? null;

  const hasTovFormChanged =
    tovFormMode === "edit"
      ? customName &&
        instruction &&
        selectedTovObj &&
        (customName !== selectedTovObj.name || instruction !== selectedTovObj.instruction)
      : tovFormMode === "add"
        ? customName && instruction
        : false;

  const handleDelete = async () => {
    try {
      setLoadingOnSave(true);
      await deleteCustomTovs(selectedTovObj.id);
      const updatedTovs = customTovs.filter((tov) => tov.name !== selectedTovName);
      setCustomTovs(updatedTovs);
      setSelectedTovName(updatedTovs[0]?.name ?? "");
      setShowDeleteView(false);
      setShowTovForm(false);
      setCustomName("");
      setInstruction("");
      setTovFormMode("");
      setTypeSelection("brand");
      setTovOption("brand");
      const response = await getDefaultValues();
      const defaultRes =
        Object.keys(response.default_tone_of_voice).length > 0
          ? response.default_tone_of_voice
          : response.tone_of_voice;
      setTempSelectedDivision(defaultRes?.division ?? "");
      setTempSelectedBrand(defaultRes?.brand ?? EMPTY_BRAND);
      setTempSelectedPersona(defaultRes?.persona ?? PERSONA_INITIAL_OBJECT);
      setSelectedTovId(defaultRes?.tov_id ?? "");
    } catch (error) {
      console.error(error);
      showApiErrorToast("Something went wrong.");
    } finally {
      setLoadingOnSave(false);
    }
  };

  return {
    customTovs,
    setCustomTovs,
    selectedTovName,
    setSelectedTovName,
    customName,
    setCustomName,
    instruction,
    setInstruction,
    selectedTovObj,
    hasTovFormChanged,
    handleDelete,
  };
};

export default useToneOfVoice;
